/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".happ-button-list[_ngcontent-%COMP%]{background:#fff;margin:5px;font-size:18px;padding:5px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;display:inline-block}.happ-list[_ngcontent-%COMP%]{flex-wrap:wrap}.happ-small-button[_ngcontent-%COMP%]{line-height:25px!important}"];
export { styles as styles };
